<template>
  <div :class="{deleted: ticket.isDeleted}">
    <div class="a-vs-b--single-bet__body">
        <div class="a-vs-b--single-bet__body--top">
          <span v-if="ticket.isDeleted">{{$t('match')}} #</span>
          <span v-if="!ticket.isDeleted">{{$t('match')}} {{ticket.match + 1}}</span>
          <span>{{$t('round')}}: {{ ticket.EventID % 1000 }}</span>
        </div>

        <div class="a-vs-b--single-bet__body--middle">
          <span>{{ extractHomeTeamName(ticket) }}</span> :
          <span>{{ extractAwayTeamName(ticket) }}</span>
        </div>

        <div class="a-vs-b--single-bet__body--bottom" v-if="ticket.activeStake">
          <span>
            {{$t(ticket.activeStake.TableName)}}:
            <b>{{$t(ticket.activeStake.TableSubname)}} {{ticket.activeStake.Title}}</b>
          </span>
          <span>
            {{$t('quota')}}: <b>{{ format(extractQuota(ticket)) }}</b>
          </span>
        </div>
     </div>

     <div class="a-vs-b--single-bet__head" :class="{deleted: ticket.isDeleted}" @click="onDelete()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
        </svg>
     </div>
   </div>
</template>

<script>

import NumberFormat from '@/mixins/NumberFormat'
import VSoccerTicketHelper from '@/mixins/VSoccerTicketHelper'
import LanguageHelper from '@/mixins/LanguageHelper'

import vuexStore from '../../../store/vuexStore'

import deleteStake from '../../../assets/audio/vSoccer/reset_bet.mp3'

export default {
  mixins: [NumberFormat, VSoccerTicketHelper, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    onDelete: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(deleteStake)
        audio.play()
      }
      this.$emit('onDelete')
    },
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    }
  }
}
</script>
